import { configureStore } from '@reduxjs/toolkit';
import ipInformationReducer from '../features/ipInformationSlice';
import fetchErrors from '../features/errorsSlice';

export const store = configureStore({
  reducer: {
    information: ipInformationReducer,
    errors: fetchErrors
  },
});
